import React from "react";
import { Star } from "lucide-react";
import { EcommerceProductsProvider, useEcommerceProducts, AddToCartButton } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
const wp_query_params = {
  per_page: 6,
  orderby: "date",
  order: "desc",
  status: "publish"
};
const wp_query = new WP_Query(wp_query_params);
function TrendingProductsConsumer() {
  const {
    products,
    loading,
    error,
    refetch
  } = useEcommerceProducts();
  if (loading) {
    return <div data-section-id="63955" className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
        {[...Array(3)].map((_, i) => <div key={i} data-index={i} className="h-[400px] w-full animate-pulse rounded-xl bg-accent/30" />)}
      </div>;
  }
  if (error) {
    return <div className="flex flex-col items-center justify-center py-12 text-center">
        <p className="mb-4 text-muted-foreground">Unable to load our featured essentials.</p>
        <Button variant="outline" onClick={refetch}>
          Try Again
        </Button>
      </div>;
  }
  if (products.length === 0) {
    return <p className="text-center text-muted-foreground">No featured essentials found at this time.</p>;
  }
  return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
      {products.map((product, i) => <div key={product.id} data-index={i} className="group relative flex flex-col overflow-hidden rounded-xl border border-border bg-card transition-all duration-300 hover:shadow-xl hover:-translate-y-1">
          {}
          <div className="relative aspect-[4/5] w-full overflow-hidden bg-muted/50">
            <Link to={product.link} className="block h-full w-full">
              {}
              {product.featured_image_url ? <img src={product.featured_image_url} alt={product.title} className="h-full w-full object-cover transition-all duration-500 group-hover:scale-105 group-hover:opacity-0" loading="lazy" /> : <div className="flex h-full w-full items-center justify-center bg-accent/20 text-muted-foreground">
                  No Image
                </div>}

              {}
              {product.featured_image_url && <img src={product.customFields?.hover_image || product.featured_image_url} alt={`${product.title} - Alternate View`} className="absolute inset-0 h-full w-full object-cover opacity-0 transition-all duration-500 group-hover:scale-105 group-hover:opacity-100" loading="lazy" />}
            </Link>

            {}
            <div className="absolute top-4 left-4 z-10">
              <Badge variant="secondary" className="bg-accent/80 text-accent-foreground shadow-sm backdrop-blur-md border-none">
                okfun Select
              </Badge>
            </div>
          </div>

          {}
          <div className="flex flex-1 flex-col p-5">
            <div className="mb-2 flex items-center gap-1">
              {[...Array(5)].map((_, starIndex) => <Star key={starIndex} className={`h-3.5 w-3.5 ${starIndex < (product.customFields?.average_rating || 5) ? "fill-primary text-primary" : "fill-muted text-muted"}`} />)}
              <span className="ml-2 text-xs text-muted-foreground">
                ({product.customFields?.review_count || "4.9"})
              </span>
            </div>

            <Link to={product.link} className="mb-2 block">
              <h3 className="line-clamp-1 text-lg font-semibold text-foreground transition-colors group-hover:text-primary">
                okfun {product.title}
              </h3>
            </Link>

            <div className="mt-auto flex items-center justify-between gap-4 pt-4">
              <div className="flex flex-col">
                <span className="text-xl font-bold text-primary">
                  ${product.price.toFixed(2)}
                </span>
                {product.discounted_price && <span className="text-sm text-muted-foreground line-through">
                    ${product.discounted_price.toFixed(2)}
                  </span>}
              </div>

              <div className="w-32 shrink-0">
                <AddToCartButton productId={product.id} variant="default" size="sm" text="Add to Cart" className="w-full" buttonClassName="w-full bg-primary text-primary-foreground hover:bg-primary/90 shadow-md transition-transform hover:scale-105" showQuantity={false} />
              </div>
            </div>
          </div>
        </div>)}
    </div>;
}
export default function TrendingProblemSolvers() {
  return <section id="featured-okfun-essentials" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4">
        <div className="mb-12 text-center">
          <h2 className="mb-4 text-3xl font-bold tracking-tight text-foreground md:text-4xl lg:text-5xl">
            Featured okfun Essentials
          </h2>
          <p className="mx-auto max-w-2xl text-lg text-muted-foreground leading-relaxed">
            Professional-grade health monitoring and personal wellness innovations curated for your modern lifestyle and vitality.
          </p>
        </div>

        <EcommerceProductsProvider wp_query={{
        per_page: 6,
        orderby: "date",
        order: "desc",
        status: ["publish"]
      }} className="w-full">
          <TrendingProductsConsumer />
        </EcommerceProductsProvider>

        <div className="mt-12 text-center">
          <Link to="/ProfessionalMedicalPage">
            <Button variant="outline" size="lg" className="min-w-[200px] border-primary/30 text-primary hover:bg-accent hover:text-primary-foreground transition-all duration-300 rounded-full">
              Explore All Wellness
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}